import React from "react";
import { ViewIcon } from "../../../icons";
import PostShare from "./PostShare";
import { POST_STATUS } from "../../../common/constants";

const PostPreviewAnalytics = props => {
  const { views, postTitle, postLink, status } = props;
  return (
    <React.Fragment>
      <div className="events-page-post-static">
        <div className="events-page-post-static-item">
          <div className="events-page-post-static-item-text">
            <ViewIcon />
            {views?.total || "0"} views
          </div>
        </div>
        {status === POST_STATUS?.[4]?.value ||
        status === POST_STATUS?.[5]?.value ? (
          <div className="events-page-post-static-item events-page-post-static-item-right">
            <PostShare title={postTitle} url={postLink} />
          </div>
        ) : null}
      </div>
    </React.Fragment>
  );
};

export default PostPreviewAnalytics;
